import { Trigger as r, List as n } from "./atoms-v2738.js";
import i, { css as s } from "styled-components";
import { Text as a } from "./atoms-v243.js";
import { breakpoints as d } from "./atoms-v2125.js";
const g = i(r)`
  align-items: center;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid
    ${({ $colorTheme: t, $isSelected: o, theme: e }) => e.get(`tokens.border.${t}.${o ? "main" : "light"}`)};
  box-sizing: border-box;
  color: ${({ $colorTheme: t, theme: o }) => o.get(`tokens.colors.text.${t}.primary`)};
  cursor: pointer;
  display: flex;
  gap: 8px;
  justify-content: center;
  max-height: 42px;
  min-width: 0;
  padding: ${({ $size: t }) => t === "small" ? "12px 16px" : "19px 16px"};
  position: relative;

  &:focus-visible {
    outline: 1px solid ${({ theme: t }) => t.get("tokens.colors.focus.focus")};
  }

  &:hover {
    ${({ $colorTheme: t, $isSelected: o, theme: e }) => !o && e.get(`tokens.border.${t}.dark`)};
  }

  &:disabled {
    border-bottom: 1px solid ${({ $colorTheme: t, theme: o }) => o.get(`tokens.border.${t}.disabled`)};
    color: ${({ $colorTheme: t, theme: o }) => o.get(`tokens.text.${t}.disabled`)};
    cursor: default;
  }

  &::after {
    background-color: ${({ $colorTheme: t, $isSelected: o, theme: e }) => o ? e.get(`tokens.border.${t}.main`) : "transparent"};
    bottom: 0;
    content: '';
    height: 1px;
    left: 0;
    position: absolute;
    width: 100%;
  }

  @media ${d.large} {
    max-height: 57px;
  }

  ${({ $hasOwnLabel: t }) => t && s`
      padding: 0;
    `}
`, b = i(n)`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 2px;
  justify-content: flex-start;
  min-width: 0;
  width: 100%;
`, m = i(a)`
  color: ${({ $colorTheme: t, $isDisabled: o, theme: e }) => e.get(`tokens.text.${t}.${o ? "disabled" : "primary"}`)};
  display: block;
  flex: ${({ $isShrinkable: t }) => t ? "1 1 auto" : "0 0 auto"};
  max-width: ${({ $isShrinkable: t }) => t ? "100%" : "auto"};
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ theme: t }) => {
  var o;
  return (o = t == null ? void 0 : t.get("tokens.body.compact-productive")) == null ? void 0 : o.toJS();
}};

  ${({ $isSelected: t, theme: o }) => {
  var e;
  return t && ((e = o.get("tokens.heading.compact-01")) == null ? void 0 : e.toJS());
}};
`, $ = i.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 18px;
`;
export {
  $ as IconBox,
  m as StyledLabel,
  g as StyledTab,
  b as StyledTabsList
};
